<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13meAxr/tc-custom/9781429954068.jpg?1740685801550" alt="This image is the cover for the book Human Disguise, Tom Wilner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Human Disguise, Tom Wilner
      </h1>
      <p class="bookDescription body article font2">
        <p>The world has been shattered.  Disease and war have ravaged the Earth.  A resurgent Germany once again threatens Europe, and the United States is engaged in the Middle-East while New York sits, an empty, radioactive ruin. The city of Miami has become a virtual prison, home to the worst life has to offer. <br/><br/>Tom Wilner lives on the outskirts of this foresaken realm. He's what this future passes off as a police officer. With his family shattered, Wilner is just a pale version of the police hero he once was. When a chance encounter in a rundown roadhouse erupts in violence, Wilner is forced to step in. <br/><br/>His exploration into the violence of that evening leads him onto the path of two ancient warring races. They have been manipulating power and control on Earth for centuries, and are about to enter into a battle for ultimate supremacy. Unless Tom Wilner puts an end to their fury.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James O'Neal
      </h2>
      
      <p class="authorDescription body article"><P>JAMES O'NEAL has published articles on history and Florida. He is a career law-enforcement officer.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?759388b7